exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tippy-tooltip.customTheme-theme{background-color:#346f8b}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SettingsStatistics.vue"],"names":[],"mappings":"AACA,iCACE,wBAA0B,CAC3B,AACD,+EACE,6BAA+B,CAChC","file":"SettingsStatistics.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme {\n  background-color: #346F8B;\n}\n.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {\n  border-left: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d0e3e0e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/System/SettingsStatistics.vue
// module id = 2240
// module chunks = 33